<template>
    <div id="softwareSuggestions" class="background-ash pl20 pr20 pb20">
        <!--搜索条件-->
        <div class="search_list background-white">
		   <ul class="lists">
				<li>
                    <span>时间</span>
                    <el-date-picker  size="small" v-model="time1" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
				<li>
                    <span>状态</span>
                     <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.status" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="未处理" value="INIT"></el-option>
                        <el-option label="已处理" value="PROCESSED"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns">
                <el-button size="small" type="primary"  @click="searchGetDataList">搜索</el-button>
            </div>
	   </div>
       <!--内容-->
       <div class="content pt20">
           <!--表头操作-->
           <div class="watchBar">
               <div class="btns right">
                   <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
               </div>
           </div>
           <div class="tab">
               <el-table ref="checkList"  size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                   <el-table-column type="index" label="序号" class="type"></el-table-column>
                   <el-table-column label="用户账号" prop="account"></el-table-column>
                   <el-table-column label="企业名称" prop="companyName"></el-table-column>
                   <el-table-column label="时间" prop="gmtRecommend"></el-table-column>
                   <el-table-column label="联系人" prop="linkName"></el-table-column>
                   <el-table-column label="联系方式" prop="linkMode"></el-table-column>
                   <el-table-column label="建议内容">
                        <template slot-scope="scope">
                            <span>{{scope.row.content}}<span class="copy" @click="copyFunc(scope.row.id)">复制</span></span>
                            <input class="copy-content" type="text" :value="scope.row.content" :id="scope.row.id"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="处理状态">
                        <template slot-scope="scope" >
                           <div style="padding:8px 15px;" v-if="scope.row.status !== 'INIT'">已处理</div>
                           <el-button type="text" size="small" v-else @click="stateHandling(scope.row)">未处理</el-button>
                        </template>
                    </el-table-column>
               </el-table>
           </div>
           <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList" :current-page.sync="getDataParam.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
       </div>
       <!--标记说明-->
       <el-dialog  title="标记说明" :visible.sync="isSign" class="nopad" width="380px" >
            <el-form :model="form" status-icon ref="ruleForm" :rules="rules" label-width="85px" class="demo-ruleForm">
                <el-form-item label="标记说明" prop="processMemo" class="last-form-item">
                    <el-input type="textarea" v-model="form.processMemo"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="isSign = !isSign">取 消</el-button>
                <el-button size="small" type="primary" @click="sureSign">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
	name: 'softwareSuggestions', //软件建议
	data () {
		return {
			getDataParam: {
                geGmtRecommend: '', //建议开始时间
                leGmtRecommend: '', //建议结束时间
                status: 'all', //INIT未处理，PROCESSED已处理
                page:1,
                size:10
            },
            dataList: [],
            totalCount: 0,
            time1: '',
            isSign: false,
            form: {
                processMemo: ''
            },
            rules: {
                processMemo: [{required:true,message:'请输入标记说明',trigger:'blur'},
                            { min: 1, max: 300, message: '长度在 1 到 300 个字符', trigger: 'blur' }]
            },
		}
	},
	watch: {
        isSign (val) {
            if (!val) {
                this.clearForm();
            } 
        }
	},
	methods: {
		getDataList () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtRecommend = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtRecommend = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtRecommend = "";
                this.getDataParam.leGmtRecommend = "";
            }
            let param = {...this.getDataParam};            
            if (param.status === 'all') {
                param.status = null;
            }
            param.page = (param.page - 1);
            this.$http('POST', '/admin/recommend/soft/page', {}, param, (status, res) => {
                if (status) {
                   if(!!res.content && res.content.length > 0) {
                       this.dataList = res.content;
                       this.totalCount = res.totalCount;
                   }else {
                       this.dataList = [];
                       this.totalCount = 0;
                   }
                }
            })
        },
        searchGetDataList () {
            this.getDataParam.page = 1;
            this.getDataList();
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        getExport () {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtRecommend = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtRecommend = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtRecommend = "";
                this.getDataParam.leGmtRecommend = "";
            }
            let param = {...this.getDataParam};            
            if (param.status === 'all') {
                param.status = null;
            }        
            const loading = this.load();
            this.$http('POST', '/admin/recommend/soft/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                   if (res.status === '200') {
                       this.educe(res.data);
                   }
                }
            })
        },
        //复制
        copyFunc (id) {
            let input = document.getElementById(id);
            input.select();
            document.execCommand('copy',false); 
        },
        clearForm () {
            this.form.processMemo = '';
            this.$refs.ruleForm.resetFields();
        },
        stateHandling (item) {
            this.form.id = item.id;
            this.isSign = true;
        },
        sureSign () {
             this.$refs.ruleForm.validate( (status) => {
                 if (status) {
                    this.$http('POST', '/admin/recommend/soft/process', {}, this.form, (status, res) => {                        
                        if (status) {
                            if (res.status === '200') {
                                this.$message({type: 'success', message: res.message});
                                this.isSign = false;
                                this.getDataList();
                            } else {
                                this.$message({type: 'error', message: res.message});
                            }                            
                        }
                    });
                }
             })
        },
	},
	mounted () {
        this.getDataList();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#softwareSuggestions {width: 100%;height: calc(100vh - 132px);}
#softwareSuggestions .content {height: calc(100% - 76px);}
#softwareSuggestions .content .tab {height: calc(100% - 125px);}
#softwareSuggestions .copy{cursor: pointer; color:#2480ED;}
#softwareSuggestions .copy-content{width: 5px; height: 5px; opacity: 0;}
</style>



// WEBPACK FOOTER //
// src/views/userSuggestions/softwareSuggestions.vue